import React from "react";
import classNames from "classnames";
import Bouton from "../../bouton";
import Icon from "../../icon";

import styles from "./teamMember.module.scss";
import Image from "next/legacy/image";

interface ITeamMember {
    className?: string;
    contenu: {
        description: string;
        id: number;
        imageUrl: string;
        nom: string;
        type: string;
    };
    idDescription: number;
    onClick: (id: number) => void;
}

const TeamMember = ({ className = "", contenu, idDescription, onClick }: ITeamMember) => {
    const { description, id, imageUrl, nom, type } = contenu;

    const isOpen = id === idDescription;

    return (
        <div
            data-component="TeamMember"
            className={classNames(styles.me, {
                [className]: className,
            })}
        >
            <div className={styles.container}>
                <div className={styles.frame}>
                    <Bouton withStyles={false} onClick={() => onClick(id)}>
                        <Image
                            src={imageUrl}
                            alt={nom}
                            className={styles.image}
                            width={300}
                            height={300}
                        />
                    </Bouton>
                </div>
                <div>
                    <div className={styles.titleZone}>
                        <Bouton withStyles={false} onClick={() => onClick(id)}>
                            <h3 className={styles.title}>{nom}</h3>
                        </Bouton>
                        <span className={styles.job}>{type}</span>
                    </div>
                    {description && (
                        <Bouton
                            id={`button-${id}-${nom.replace(/\s/g, "")}`}
                            className={styles.button}
                            onClick={() => onClick(id)}
                            ariaLabel={isOpen ? "moins" : "plus"}
                            withStyles={false}
                        >
                            <Icon
                                ariaLabelledBy={`button-${id}-${nom.replace(/\s/g, "")}`}
                                icon={isOpen ? "fleche-up" : "fleche-down"}
                            />
                        </Bouton>
                    )}
                </div>
            </div>
            {isOpen && description && <span className={styles.whiteSpace} />}
        </div>
    );
};

export default TeamMember;
